const ua = /Android|webOS|iPhone|iPad|iPod|BlackBerry|IEMobile|Opera Mini/i;

function calcIsMobile() {
    return ua.test(navigator.userAgent) || window.innerWidth < 1024;
}

window.device = {
    isMobile: calcIsMobile(),
    get isDesktop() {
        return !this.isMobile;
    },
};

['load', 'resize'].forEach((event) => {
    window.addEventListener(event, () => {
        window.device.isMobile = calcIsMobile();
    });
});
